import L from "./index84.mjs";
import M from "./index85.mjs";
import U from "./index86.mjs";
import { useContext as J, useState as K, useRef as w, useEffect as O } from "react";
import { I18nContext as R, ReportNamespaces as Y } from "./index87.mjs";
import { warnOnce as E, hasLoadedNamespace as k, loadLanguages as T, loadNamespaces as C } from "./index88.mjs";
import { getI18n as q } from "./index89.mjs";
import { getDefaults as B } from "./index90.mjs";
function F(o, n) {
  var t = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(o);
    n && (r = r.filter(function(y) {
      return Object.getOwnPropertyDescriptor(o, y).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function S(o) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? F(Object(t), !0).forEach(function(r) {
      M(o, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(t)) : F(Object(t)).forEach(function(r) {
      Object.defineProperty(o, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return o;
}
var D = function(n, t) {
  var r = w();
  return O(function() {
    r.current = n;
  }, [n, t]), r.current;
};
function ee(o) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.i18n, r = J(R) || {}, y = r.i18n, A = r.defaultNS, e = t || y || q();
  if (e && !e.reportNamespaces && (e.reportNamespaces = new Y()), !e) {
    E("You will need to pass in an i18next instance by using initReactI18next");
    var P = function(f, a) {
      return typeof a == "string" ? a : a && U(a) === "object" && typeof a.defaultValue == "string" ? a.defaultValue : Array.isArray(f) ? f[f.length - 1] : f;
    }, v = [P, {}, !1];
    return v.t = P, v.i18n = {}, v.ready = !1, v;
  }
  e.options.react && e.options.react.wait !== void 0 && E("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  var c = S(S(S({}, B()), e.options.react), n), h = c.useSuspense, j = c.keyPrefix, i = o || A || e.options && e.options.defaultNS;
  i = typeof i == "string" ? [i] : i || ["translation"], e.reportNamespaces.addUsedNamespaces && e.reportNamespaces.addUsedNamespaces(i);
  var p = (e.isInitialized || e.initializedStoreOnce) && i.every(function(s) {
    return k(s, e, c);
  });
  function m() {
    return e.getFixedT(n.lng || null, c.nsMode === "fallback" ? i : i[0], j);
  }
  var z = K(m), N = L(z, 2), x = N[0], d = N[1], l = i.join();
  n.lng && (l = "".concat(n.lng).concat(l));
  var I = D(l), u = w(!0);
  O(function() {
    var s = c.bindI18n, f = c.bindI18nStore;
    u.current = !0, !p && !h && (n.lng ? T(e, n.lng, i, function() {
      u.current && d(m);
    }) : C(e, i, function() {
      u.current && d(m);
    })), p && I && I !== l && u.current && d(m);
    function a() {
      u.current && d(m);
    }
    return s && e && e.on(s, a), f && e && e.store.on(f, a), function() {
      u.current = !1, s && e && s.split(" ").forEach(function(b) {
        return e.off(b, a);
      }), f && e && f.split(" ").forEach(function(b) {
        return e.store.off(b, a);
      });
    };
  }, [e, l]);
  var _ = w(!0);
  O(function() {
    u.current && !_.current && d(m), _.current = !1;
  }, [e, j]);
  var g = [x, e, p];
  if (g.t = x, g.i18n = e, g.ready = p, p || !p && !h) return g;
  throw new Promise(function(s) {
    n.lng ? T(e, n.lng, i, function() {
      return s();
    }) : C(e, i, function() {
      return s();
    });
  });
}
export {
  ee as useTranslation
};
